import { type BRAND_TYPE, ENV_TYPE, } from '@/enums/configs';

/** 当前运行环境 */
let ENV: ENV_TYPE;

/** 当前品牌 */
let BRAND
  = new URL(window.location.href).searchParams.get('brand')
  || (process.env.BRAND as BRAND_TYPE);

/** 是否在 LG 容器中 */
export const isLg = navigator.userAgent.includes('lg _dsbridge');

/** 是否在 SalesPadCN APP 中 */
export const isCNLg = isLg && /SalesPadCN/i.test(navigator.userAgent);

/** 是否在 Mate APP 中 */
export const isMate = isLg && /Mate/i.test(navigator.userAgent);
/**
 * 判断是否是安卓设备
 * @returns
 */
export const isAndroid = () => /android/i.test(navigator.userAgent.toLowerCase());

/**
 *  判断是否在微信环境浏览器内
 * @returns
 */
export const isWeiXin = () => /micromessenger/i.test(navigator.userAgent.toLowerCase());

/**
 *  判断是否在微博环境内
 * @returns
 */
export const isWeiBo = () => /weibo/i.test(navigator.userAgent.toLowerCase());

/** 获取当前品牌 */
export const getBrand = () => BRAND;

/** 设置当前品牌 */
export const setBrand = (brand: BRAND_TYPE) => {
  BRAND = brand;
};

/** 判断当前是否是FY品牌 */
export const isFy = process.env.BRAND === 'fy';

/** 判断当前是否是ONVO品牌 */
export const isAlps = process.env.BRAND === 'alps';

/** 判断当前是否是NIO品牌 */
export const isNio = process.env.BRAND === 'nio';

/** 根据域名获取当前环境 */
export const getEnvByHost = () => {
  const { hostname, } = window.location;

  if (/-dev|localhost|-local|(\d{1,3}\.){3}/.test(hostname)) {
    return ENV_TYPE.DEV;
  }
  if (/-test|-sit/.test(hostname)) {
    return ENV_TYPE.TEST;
  }
  if (/-stg/.test(hostname)) {
    return ENV_TYPE.STG;
  }
  return ENV_TYPE.PROD;
};

/** 获取当前运行环境 */
export const getEnv = () => {
  if (ENV) {
    return ENV;
  }
  let env: string | undefined;

  env = getEnvByHost();

  if (import.meta.env.VITE_API_ENV) {
    env = import.meta.env.VITE_API_ENV;
  }

  ENV = (env?.toLowerCase() as ENV_TYPE) || ENV_TYPE.PROD;

  return ENV;
};
